module.exports = __webpack_public_path__ + "static/images/dhl-fea6b8e0.png";